import * as React from 'react';
import { connect } from 'react-redux';
import { TroughModel } from 'franke-trough-dependencies';
import { GlobalPrivateState, ActiveFilterValue, setFilters, listOfActiveFilters } from 'src/api';
import TroughListLargeItem from './TroughListLargeItem';

import './TroughListLargeItem.scss';
import './TroughListLarge.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './TroughListLarge.messages';
import { isConfigurationEditable, isConfigurationEditableByCurrentUser } from 'src/redux/utils.redux';

export interface TroughListLargeLargeProps {
  filter: GlobalPrivateState['queryState']['params']['filter'];
  params: GlobalPrivateState['queryState']['params'];
  troughs: GlobalPrivateState['troughs'];
}

export interface TroughListLargeLargeState {
}

export class TroughListLargeLargePartial extends React.Component<TroughListLargeLargeProps, TroughListLargeLargeState> {
  constructor(props: TroughListLargeLargeProps) {
    super(props);
  }

  public render() {
    const { troughs } = this.props;
    return (
      <div className="partial-trough-list-options">
        <div className="trough-list-large-partial">
          <div className="select-trough-body">
            <div className="trough trough-selection">
              <div className="row h-100">
              {troughs && troughs.result && troughs.result.length > 0 && (
                <div className={`trough-selection-wrap d-flex align-content-start flex-wrap ${this.activeFilter ? 'active-select' : ''}`}>
                  {troughs.result.map((trough, index) => {
                    if (trough.deleted) { return; } // Hide in front-end, because the trough could still be used for an existing config which we dont want to break

                    const key = `troughs_list_item_${index}_${trough.id}`;
                    return( 
                      <TroughListLargeItem 
                        activeFilters={this.activeFilter}
                        key={key} 
                        trough={trough} 
                        disable={this.disableTrough(trough)} 
                        troughId={trough.id}
                      />
                    );
                  })}
                </div>
              )}
              {troughs && troughs.result && troughs.result.length === 0 && (
                <div className={`trough-selection-wrap align-content-end flex-wrap`}>
                  <div>
                    <h3> 
                      <FormattedMessage {...MESSAGES.troughListSorryMsg} />
                    </h3>  
                  </div>
                </div>
              )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private get activeFilter(): ActiveFilterValue[] | undefined {
    const { filter } = this.props;
    const activeList = filter && setFilters(filter);
    
    if (!activeList) {
      return;
    }

    return listOfActiveFilters(activeList);
  }

  private disableTrough(trough: TroughModel): boolean {
    const { params } = this.props;
    
    if (!isConfigurationEditable()) {
      return true;
    }

    let touched = false;
    if (params && params.filter) {
      for (const key in params.filter) {
        if (params.filter[key]) {
          touched = true;
          if (trough[key]) { return false; }
        }
      }
    }
    return touched; // some filters are applied but no active filter is set true in given trough
  }
}

export const TroughListLargeLarge = connect((state: GlobalPrivateState) => ({
  filter: state.queryState.params.filter,
  params: state.queryState.params,
  troughs: state.troughs,
}))(TroughListLargeLargePartial);

export default TroughListLargeLarge;

